import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import DraggableList from '@/components/DraggableList.vue';
import MyDialog from '@/components/MyDialog.vue';
import TextEditor from '@/components/TextEditor.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
let CharacterSheetCustomFeatures = class CharacterSheetCustomFeatures extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.name = '';
        this.content = '';
    }
    resetValues() {
        this.name = '';
        this.content = '';
    }
    addItem() {
        this.$emit('updateCharacter', { customFeatures: { [this.features.length]: {
                    name: this.name,
                    content: this.content
                } } });
        this.isOpen = false;
    }
    handleEdit(field, newValue, index) {
        this.$emit('updateCharacter', { customFeatures: { [index]: { [field]: newValue } } });
    }
    isEmptyString(input) {
        return input.length > 0;
    }
};
__decorate([
    Prop(Array)
], CharacterSheetCustomFeatures.prototype, "features", void 0);
CharacterSheetCustomFeatures = __decorate([
    Component({
        components: {
            DraggableList,
            MyDialog,
            TextEditor,
            ConfirmDelete
        }
    })
], CharacterSheetCustomFeatures);
export default CharacterSheetCustomFeatures;
